import { computed, Ref } from '@nuxtjs/composition-api';
import { IConfig } from '@shared/types/IBreakpoint';

const useVisibility = (props: any, config: Ref<IConfig>) => {
  const showHeaderText = computed(() => !!props.title || showDescription.value);

  const showDescription = computed(() => !!props.description && config.value.showDescription);

  const showSteppers = computed(
    () => config.value.cardMode === 'scroll' && config.value.showSteppers,
  );

  const showHeader = computed(() => showHeaderText.value || showHeaderActions.value);

  const showHeaderActions = computed(() => !!props.link || showSteppers.value);

  return {
    showDescription,
    showHeaderText,
    showSteppers,
    showHeaderActions,
    showHeader,
  };
};

export default useVisibility;
